'use strict'

require '../../src/frontend/desktop_sls'
